export const SchedulingTable = ({children, weeklyView}) => {
    return (
        <div className={`middle-down ${weeklyView && "mt-2"}`}>
            <div className="content-wrapper" style={{height: 'auto'}}>
                {children}
            </div>
        </div>
    )
}